export const ShortcutKeys = {
  Undo: ['ctrl+z', 'command+z'],
  Redo: ['ctrl+y', 'command+y'],
};
